import {Col, Row} from "reactstrap";
import React from "react";

const DadosAutoridadeDetalhes = props => {
    const gerarConteudoCampo = data => {
        let content = [];
        //? Itera sobre os arrays, usa o tamanho do array da descricao como base
        for (
            let contSeqSecao = 0;
            contSeqSecao < data.descricao.length;
            contSeqSecao++
        ) {
            let descricao = data.descricao[contSeqSecao];
            let pontuacao = data.pontuacao[contSeqSecao];
            content.push(
                <span
                    key={`info__${data.paragrafo}${contSeqSecao}`}
                    className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                >
                    {`${descricao}${pontuacao}`}
                </span>,
            );
        }
        return (
            <div
                key={`seqPar${data.seq_paragrafo}`}
                className="s14 text-justify"
            >
                {content}
            </div>
        );
    };

    return (
        <Row className="pad5 animated fadeIn">
            <Col xs="12" md="12">
                {props.dados.map(campo => (
                    <Row
                        className="b-w1 b-cinza2 b-solid-bottom pad5 b5"
                        key={`field__${campo.ordem}`}
                    >
                        <Col xs="12" md="3">
                            <span className="f400 preto70 s14">
                                {campo.texto}:{' '}
                            </span>
                        </Col>
                        <Col xs="12" md="9">
                            {campo.campos.map((c, index) => (
                                <div key={index} style={{ display: 'inline' }}>
                                    {gerarConteudoCampo(c)}
                                    {campo.campos[index + 1] && (
                                        <span className="l10 r10 cortxt70">
                                            {' '}
                                            |{' '}
                                        </span>
                                    )}
                                </div>
                            ))}
                        </Col>
                    </Row>
                ))}
            </Col>
        </Row>
    );
};

export default DadosAutoridadeDetalhes;
